import { CSSObject } from '@emotion/react';

export function coverStyles(offset: number | string = 0): CSSObject {
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        left: offset,
        bottom: offset,
    };
}
